import { SpriteConstant } from './../../../constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FirebaseConstant } from '../../../constant/firebase.constant';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { UtilService } from 'src/app/util/UtilService';
import { PageConstant } from 'src/app/constant/page.constant';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class FavoriteInfoLayoutComponent implements OnInit, OnChanges {
  private resizeTimeOut;
  @Input() data: any;
  @Input() userCurrency;
  @Output() eventEmit: EventEmitter<any> = new EventEmitter<any>();
  @Input() currentLanguage = 'en';
  isDeletePopup = false;
  favoritesList = [];
  selectedIndex = -1;
  deviceImage;
  _subscriptionScale;

  public contentWidth = 0;
  public contentHeight = 0;
  public optionImage: Object = {
    image_0: 'option_unselect',
    image_1: 'option_select',
  };

  common_icons: any;
  menu_icons: any;

  version = '';
  constructor(
    public firebaseAnalyticsServices: FirebaseAnalyticsService,
    public _utilService: UtilService
  ) {
    this.menu_icons = SpriteConstant.MENU_ICONS;
    this.common_icons = SpriteConstant.COMMON_ICONS;
    this.setContentHeight();
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subKKKKKKscriptionScale');
      this.resizeTimeOut = setTimeout(() => {
        this.setContentHeight();
        window.clearTimeout(this.resizeTimeOut);
        delete this.resizeTimeOut;
      }, 300);
    });
  }

  setContentHeight = () => {
    //console.log('setContentHeight setContentHeight setContentHeight setContentHeight');
    this.contentWidth = window.screen.availWidth;
    this.contentHeight =
      this._utilService.parentHeight != 0
        ? this._utilService.parentHeight
        : window.innerHeight;
  };

  ngOnInit() {
    this.version = PageConstant.VERSION;
    // console.log('FavoritesDesktopPoup');
    // console.log(this.data);
    this.computeFavoriteList();
  }

  ngOnChanges() {
    // console.log('FavoritesDesktopPoup');
    // console.log(this.data);
    this.computeFavoriteList();
    if (this.data.currentLanguage) {
      this.currentLanguage = this.data.currentLanguage;
    }
  }

  computeFavoriteList() {}

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (this.isDeletePopup) {
      this.onDeleteNo();
    } else {
      this.onCloseClick();
    }
  }

  onCloseClick = (event = null) => {
    if (FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose']) {
      this.firebaseAnalyticsServices.triggerFirebase(
        FirebaseConstant.LOBBYDESKTOPHEADER,
        'favoritesClose'
      );
    }
    this.onIconClick('close');
  };

  drop(event: CdkDragDrop<string[]>) {
    // console.log(this.favoritesList);
    // console.log('=======================');
    // console.log(event);
    moveItemInArray(
      this.favoritesList,
      event.previousIndex,
      event.currentIndex
    );
    // console.log(this.favoritesList);
    const obj: any = {};
    obj.action = 'rearrange';
    obj.previousIndex = event.previousIndex;
    obj.currentIndex = event.currentIndex;
    this.eventEmit.emit(obj);
  }

  onIconClick = (action, index = -1) => {
    const obj: any = {};
    obj.action = action;
    switch (action) {
      case 'play':
        if (FirebaseConstant.LOBBYDESKTOPHEADER['favoritesplay']) {
          this.firebaseAnalyticsServices.triggerFirebase(
            FirebaseConstant.LOBBYDESKTOPHEADER,
            'favoritesplay'
          );
        }
        obj.item = this.favoritesList[index];
        this.eventEmit.emit(obj);
        break;
      case 'delete':
        this.selectedIndex = index;
        this.showDeletePopup();
        break;
      case 'close':
        if (FirebaseConstant.LOBBYDESKTOPHEADER['favoritesClose']) {
          this.firebaseAnalyticsServices.triggerFirebase(
            FirebaseConstant.LOBBYDESKTOPHEADER,
            'favoritesClose'
          );
        }
        obj.action = action;
        this.eventEmit.emit(obj);
        break;
    }
  };

  showDeletePopup() {
    this.isDeletePopup = true;
  }

  onDeleteYes = (event) => {
    const obj: any = {};
    obj.action = 'delete';
    obj.item = this.data.favoriteList[this.selectedIndex];
    this.eventEmit.emit(obj);
    this.selectedIndex = -1;
    this.isDeletePopup = false;
  };
  onDeleteNo = (event = null) => {
    this.selectedIndex = -1;
    this.isDeletePopup = false;
  };

  ngOnDestroy(): void {
    if (this.resizeTimeOut) {
      window.clearTimeout(this.resizeTimeOut);
    }
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this.resizeTimeOut;
    delete this._subscriptionScale;
  }
}
